import AirDatepicker from 'air-datepicker';

const localeEn = {
  days: [
    'Неділя',
    'Понеділок',
    'Вівторок',
    'Середа',
    'Четвер',
    "П'ятниця",
    'Субота',
  ],
  daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  daysMin: ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
  months: [
    'Січень',
    'Лютий',
    'Березень',
    'Квітень',
    'Травень',
    'Червень',
    'Липень',
    'Серпень',
    'Вересень',
    'Жовтень',
    'Листопад',
    'Грудень',
  ],
  monthsShort: [
    'Січ.',
    'Лют.',
    'Берез.',
    'Квіт.',
    'Трав.',
    'Черв.',
    'Лип.',
    'Серп.',
    'Верес.',
    'Жовт.',
    'Листоп.',
    'Груд.',
  ],
  today: 'Сьогодні',
  clear: 'Clear',
  dateFormat: 'dd/MM/yyyy',
  timeFormat: 'hh:mm aa',
  firstDay: 1,
};

window.dateInput = function dateInput() {
  if (document.getElementsByClassName('date-input')[0]) {
    const dateInputsArr = document.querySelectorAll('.date-input');
    dateInputsArr.forEach((dateInput, i) => {
      if (!dateInput.classList.contains('is-init')) {
        dateInput.classList.add('is-init');

        dateInput.setAttribute('readonly', true);

        const now = new Date();
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const currentHour = now.getHours();
        const isTodayAllowed = currentHour < 21;

        const allowedDaysString = dateInput.getAttribute('data-days');
        const allowedDaysMap = {
          Пн: 1,
          Вт: 2,
          Ср: 3,
          Чт: 4,
          Пт: 5,
          Сб: 6,
          Нд: 0,
        };
        const allowedDays = allowedDaysString
          .split(',')
          .map((day) => allowedDaysMap[day.trim()]);

        const choiceTimeSelect = document.querySelector('#choice-time');
        const timePicker = document.querySelector('#time-picker');
        let choiceTimeInitOptions = choiceTimeSelect
            ? Array.from(choiceTimeSelect.options).map(option => option.cloneNode(true))
            : null;
        let timePickerInitialValue = timePicker ? timePicker.value : null;

        const airDatepicker = new AirDatepicker(dateInput, {
          dateFormat: 'dd/MM/yyyy',
          locale: localeEn,
          minDate: today,
          onSelect({ date, formattedDate }) {
            dateInput.value = formattedDate;

            if (!dateInput.value || dateInput.value === 'undefined') {
              dateInput.value = '';
            }

            const now = new Date();
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const selectedDate = new Date(date);
            selectedDate.setHours(0, 0, 0, 0);

            if(choiceTimeSelect && choiceTimeInitOptions !== null) {
              const currentOptions = choiceTimeSelect.querySelectorAll('option');
              for (let j = 0; j < currentOptions.length; j++) {
                currentOptions[j].disabled = false;
                updateProjectMetaSelect('choice-time');
                setProjectMetaSelectValue('choice-time', '')
              }
            }

            if (timePicker) {
              const timePickerParent = timePicker.closest('.meta-time-picker');
              if(timePickerParent) {
                timePickerParent.classList.remove('is-disabled');
              }
              timePicker.value = timePickerInitialValue;
            }

            if (selectedDate.getTime() === today.getTime()) {
              const currentHour = now.getHours();
              const currentHourMathFloor = Math.floor(now.getHours());
              /*console.log(`Сьогодні, зараз ${currentHour}:00`);*/

              if(choiceTimeSelect && choiceTimeInitOptions !== null) {
                const currentOptions = choiceTimeSelect.querySelectorAll('option');
                if(Number(currentHourMathFloor) >= 14) {
                  currentOptions.forEach((option) => {
                    option.disabled = true;
                    updateProjectMetaSelect('choice-time');
                  })
                } else {
                  const currentOptions = choiceTimeSelect.querySelectorAll('option');
                  currentOptions.forEach((option) => {
                    const value = option.value;
                    const [start, end] = value.split('-').map(part => part.trim());
                    const startHour = parseInt(start);
                    const endHour = parseInt(end);

                    if(Number(currentHourMathFloor) >= startHour) {
                      option.disabled = true;
                      updateProjectMetaSelect('choice-time');
                      setProjectMetaSelectValue('choice-time', '');
                    }
                    console.log(Number(currentHourMathFloor), startHour, endHour);
                  })
                }
              } else if (timePicker) {
                if(Number(currentHourMathFloor) >= 14) {
                  const timePickerParent = timePicker.closest('.meta-time-picker');
                  if(timePickerParent) {
                    timePickerParent.classList.add('is-disabled');
                  }
                  timePicker.value = '';
                }
              }
            }

            if (window.innerWidth <= 768) {
              setTimeout(() => {
                airDatepicker.hide();
              }, 100);
            }
          },
          onRenderCell({ date, cellType }) {
            if (cellType === 'day') {
              const day = date.getDay();

              const isToday = date.getTime() === today.getTime();

              if (!allowedDays.includes(day) || date < today || (isToday && !isTodayAllowed)) {
                return {
                  disabled: true,
                  classes: 'disabled-day',
                };
              }
            }
          }
        });

        dateInput.addEventListener('input', (event) => {
          event.preventDefault();
          event.stopPropagation();
          dateInput.value = '';
        });

        /*document.addEventListener('scroll', () => {});

        document.addEventListener('wheel', (event) => {
          console.log('Wheel event triggered');
          const datepickerElement = document.querySelector('.air-datepicker');

          if (
            datepickerElement &&
            document.querySelector('#popup').classList.contains('active')
          ) {
            airDatepicker.hide();
          }
        });*/
      }
    });
  }
};
dateInput();
